import moment from "moment";
import api from "../../../services/api-configuration";

// Helper function to get values from select elements
const getSelectValues = (elementId, type) => {
    const element = document.getElementById(elementId);
    if (!element) return [];
    return Array.from(element.querySelectorAll('select option:checked'))
        .map(option => type(option.value));
};

export const getAllGroupages = async (data) => {
    const doorExitWarehouseIds = getSelectValues("depoCikisDepo", Number);
    const shippingTypeIds = getSelectValues("sevkiyatTipi", Number);
    const cityIds = getSelectValues("nereye-il", Number);
    const fromWarehouseIds = getSelectValues("grupajDepo", Number);
    const toWarehouseIds = getSelectValues("nereye", Number);
    const groupageStatus = getSelectValues("grupajStatu", String);
    const filterData = {
        groupage_nos: document.getElementById("grupajNo").value ? [document.getElementById("grupajNo").value.trim()] : null,
        shipping_start: document.getElementById("planlananSevkTarihi").childNodes[0].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("planlananSevkTarihi").childNodes[0].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 00:00:00") : null,
        shipping_end: document.getElementById("planlananSevkTarihi").childNodes[2].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("planlananSevkTarihi").childNodes[2].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 23:59:59") : null,
        approved_start: document.getElementById("grupajOnayTarih").childNodes[0].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("grupajOnayTarih").childNodes[0].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 00:00:00") : null,
        approved_end: document.getElementById("grupajOnayTarih").childNodes[2].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("grupajOnayTarih").childNodes[2].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 23:59:59") : null,
        door_exit_start: document.getElementById("depoCikisTarihi").childNodes[0].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("depoCikisTarihi").childNodes[0].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 00:00:00") : null,
        door_exit_end: document.getElementById("depoCikisTarihi").childNodes[2].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("depoCikisTarihi").childNodes[2].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 23:59:59") : null,
        blg_start: document.getElementById("bilgiGelisTarihi").childNodes[0].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("bilgiGelisTarihi").childNodes[0].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 00:00:00") : null,
        blg_end: document.getElementById("bilgiGelisTarihi").childNodes[2].childNodes[0].childNodes[0].value ?
            moment(document.getElementById("bilgiGelisTarihi").childNodes[2].childNodes[0].childNodes[0].value).format("YYYY-MM-DD 23:59:59") : null,
        statuses: groupageStatus.length > 0 ? groupageStatus : null,
        printed: document.getElementById("grupajYazdırmaDurum").childNodes[0].childNodes[0].value === "1" ? false :
            document.getElementById("grupajYazdırmaDurum").childNodes[0].childNodes[0].value === "2" ? true : null,
        to_warehouse_ids: toWarehouseIds.length > 0 ? toWarehouseIds : null,
        from_warehouse_ids: fromWarehouseIds.length > 0 ? fromWarehouseIds : null,
        chassis_no: document.getElementById("sase").value.trim() || null,
        city_id: cityIds.length > 0 ? cityIds : null,
        shipping_type_ids: shippingTypeIds.length > 0 ? shippingTypeIds : null,
        door_exit_warehouse_ids: doorExitWarehouseIds.length > 0 ? doorExitWarehouseIds : null,
    };
    const response = await api.post("/getAllGroupages", filterData);
    return response.data;
}


export const getGroupageDetails = async (data) => {
    const response = await api.post("/groupageDetails", {
        groupage_no: data
    });
    return response.data;
}

export const fetchTaseronData = async () => {
    const response = await api.post("subcontractor/getAll");
    return response.data.data || [];
};


export const getPeron = async (value) => {
    if (!value) return;

    try {
        const response = await api.post("getPeronsByWarehouses", {
            warehouse_ids: [parseInt(value)]
        });
        const all_data = response.data.data || [];

        // Sort only by numeric part after "-"
        all_data.sort((a, b) => {
            const getNumericPart = (addressCode) => {
                const parts = addressCode.split('-');
                if (parts.length >= 2) {
                    const numericPart = parseInt(parts[1], 10);
                    return isNaN(numericPart) ? 0 : numericPart;
                }
                return 0;
            };

            const numA = getNumericPart(a.address_code);
            const numB = getNumericPart(b.address_code);

            return numA - numB;
        });

        return all_data;

    } catch (error) {
        console.error("Error fetching route:", error);
    }
}


export const cancelGroupage = async (body) => {
    try {
        const response = await api.post("/cancelGroupage", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

export const approveGroupage = async (body) => {
    try {
        const response = await api.post("/approveGroupage", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

export const cancelApproval = async (body) => {
    try {
        const response = await api.post("/cancelApproval", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

export const assignTruck = async (body) => {
    try {
        const response = await api.post("/assignTruck", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

export const cancelTruckAssignment = async (body) => {
    try {
        const response = await api.post("/cancelTruckAssignment", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

// updatePlatform
export const updatePlatform = async (body) => {
    try {
        const response = await api.post("/updatePlatform", body)
        return response.data
    } catch (error) {
        console.error("Error fetching locations:", error);
    }
}

export const setPrintedColumnTrue = async (body) => {
    try {
        const response = await api.post("/setPrintedColumnTrue", body)
        return response.data
    } catch (error) {
        console.error("Error setting printed column:", error);
    }
}